import { render, staticRenderFns } from "./LeadsTable.vue?vue&type=template&id=423f587b&scoped=true"
import script from "./LeadsTable.vue?vue&type=script&lang=js"
export * from "./LeadsTable.vue?vue&type=script&lang=js"
import style0 from "./LeadsTable.vue?vue&type=style&index=0&id=423f587b&prod&scoped=true&lang=css"
import style1 from "./LeadsTable.vue?vue&type=style&index=1&id=423f587b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423f587b",
  null
  
)

export default component.exports